export const MSG_STOCK_DELETED="Stock transaction deleted successfully";
export const MSG_STOCK_UPDATED="Stock transaction updated successfully";
export const MSG_STOCK_ADDED="Stock transaction added successfully";
export const MSG_STOCK_FETCHED="Stock transaction fetched successfully";
export const MSG_STOCK_ERROR="Something went wrong, Please try again.";
export const MSG_STOCK_NOT_FOUND="Stock transaction not found";
export const MSG_STOCK_NOT_UPDATED="Stock transaction not updated";
export const MSG_STOCK_NOT_ADDED="Stock transaction not added";
export const MSG_STOCK_NOT_FETCHED="Stock transaction not fetched";
export const MSG_STOCK_CANNOT_BE_NEGATIVE = "Stock cannot be negative";
export const MSG_STOCKIN_CANNOT_BE_NEGATIVE = "Stock In cannot be negative";
export const MSG_STOCKOUT_CANNOT_BE_NEGATIVE = "Stock Out cannot be negative";
export const MSG_STOCK_DELETE_FAILED = "Failed to delete stock transaction";


export const MSG_CATEGORY_REQUIRED="Category is required";
export const MSG_ITEM_NAME_REQUIRED="Item Name is required";
export const MSG_SELL_TYPE_REQUIRED="Sell Type is required";
export const MSG_STOCK_REQUIRED="Stock is required";
export const MSG_DATE_REQUIRED="Date is required";
export const MSG_DISCOUNT_RATE_MUST_BE_POSITIVE = "Discount Rate must be greater than or equal to zero";
export const MSG_LOT_NUMBER_MUST_BE_POSITIVE = "Lot Number must be greater than or equal to zero";
export const MSG_BATCH_NUMBER_MUST_BE_POSITIVE = "Batch Number must be greater than or equal to zero";
export const MSG_REORDER_POINT_MUST_BE_POSITIVE = "Reorder Point must be greater than or equal to zero";
export const MSG_STOCK_QUANTITY_REQUIRED="Stock Quantity is required";
export const MSG_STOCK_QUANTITY_MUST_BE_POSITIVE = "Stock Quantity must be greater than or equal to zero";
export const MSG_PLEASE_FILL_ALL_REQUIRED_FIELDS="Please fill all required fields.";
export const MSG_ITEM_DETAILS_FETCH_ERROR="Failed to fetch item details. Please refresh the page.";




export const MSG_USER_DELETED="User deleted successfully";
export const MSG_USER_UPDATED="User updated successfully";
export const MSG_USER_ADDED="User added successfully";
export const MSG_USER_FETCHED="User fetched successfully";
export const MSG_USER_ERROR="Something went wrong";
export const MSG_USER_NOT_FOUND="User not found";
export const MSG_USER_NOT_UPDATED="User not updated";
export const MSG_USER_NOT_ADDED="User not added";
export const MSG_USER_NOT_FETCHED="User not fetched";
export const MSG_USER_PASSWORD_MISMATCH="Password and confirm password mismatch";
export const MSG_USER_INVALID_CREDENTIALS="Invalid credentials";

export const MSG_ORG_DELETED="Org deleted successfully";
export const MSG_ORG_UPDATED="Org updated successfully";
export const MSG_ORG_ADDED="Org added successfully";
export const MSG_ORG_FETCHED="Org fetched successfully";
export const MSG_ORG_ERROR="Something went wrong";
export const MSG_ORG_NOT_FOUND="Org not found";
export const MSG_ORG_NOT_UPDATED="Org not updated";
export const MSG_ORG_NOT_ADDED="Org not added";
export const MSG_ORG_NOT_FETCHED="Org not fetched";

export const MSG_CATEGORY_DELETED="Category deleted successfully";
export const MSG_CATEGORY_UPDATED="Category updated successfully";
export const MSG_CATEGORY_ADDED="Category added successfully";
export const MSG_CATEGORY_FETCHED="Category fetched successfully";
export const MSG_CATEGORY_ERROR="Something went wrong";
export const MSG_CATEGORY_NOT_FOUND="Category not found";
export const MSG_CATEGORY_NOT_UPDATED="Category not updated";
export const MSG_CATEGORY_NOT_ADDED="Category not added";
export const MSG_CATEGORY_NOT_FETCHED="Category not fetched";

export const MSG_SUPPLIER_DELETED="Supplier deleted successfully";
export const MSG_SUPPLIER_UPDATED="Supplier updated successfully";
export const MSG_SUPPLIER_ADDED="Supplier added successfully";
export const MSG_SUPPLIER_FETCHED="Supplier fetched successfully";
export const MSG_SUPPLIER_ERROR="Something went wrong";
export const MSG_SUPPLIER_NOT_FOUND="Supplier not found";
export const MSG_SUPPLIER_NOT_UPDATED="Supplier not updated";
export const MSG_SUPPLIER_NOT_ADDED="Supplier not added";
export const MSG_SUPPLIER_NOT_FETCHED="Supplier not fetched";

export const MSG_CUSTOMER_DELETED="Customer deleted successfully";
export const MSG_CUSTOMER_UPDATED="Customer updated successfully";
export const MSG_CUSTOMER_ADDED="Customer added successfully";
export const MSG_CUSTOMER_FETCHED="Customer fetched successfully";
export const MSG_CUSTOMER_ERROR="Something went wrong";
export const MSG_CUSTOMER_NOT_FOUND="Customer not found";
export const MSG_CUSTOMER_NOT_UPDATED="Customer not updated";
export const MSG_CUSTOMER_NOT_ADDED="Customer not added";
export const MSG_CUSTOMER_NOT_FETCHED="Customer not fetched";

export const MSG_SALES_PERSON_DELETED="Sales person deleted successfully";
export const MSG_SALES_PERSON_UPDATED="Sales person updated successfully";
export const MSG_SALES_PERSON_ADDED="Sales person added successfully";
export const MSG_SALES_PERSON_FETCHED="Sales person fetched successfully";
export const MSG_SALES_PERSON_ERROR="Something went wrong";
export const MSG_SALES_PERSON_NOT_FOUND="Sales person not found";
export const MSG_SALES_PERSON_NOT_UPDATED="Sales person not updated";
export const MSG_SALES_PERSON_NOT_ADDED="Sales person not added";
export const MSG_SALES_PERSON_NOT_FETCHED="Sales person not fetched";


export const MSG_TRANSACTION_DATA_ERROR="Error fetching transaction data";
export const MSG_ITEM_NOT_CREATED="Failed to create item";

export const MSG_ITEM_ADDED = "Item added successfully!";
export const MSG_ITEM_UPDATED = "Item updated successfully!";
export const MSG_ITEM_DELETED = "Item deleted successfully!";
export const MSG_ITEM_FETCHED = "Item fetched successfully!";
export const MSG_ITEM_ERROR = "Something went wrong while processing the item. Please try again.";
export const MSG_ITEM_NOT_FOUND = "Item not found.";
export const MSG_ITEM_NOT_UPDATED = "Item not updated.";
export const MSG_ITEM_NOT_ADDED = "Item not added.";
export const MSG_ITEM_NOT_FETCHED = "Item not fetched.";
export const MSG_COST_PRICE_REQUIRED = "Cost Price is required.";
export const MSG_COST_PRICE_MUST_BE_POSITIVE = "Cost Price must be a positive number,";
export const MSG_SELLING_PRICE_REQUIRED = "Selling Price is required.";
export const MSG_SELLING_PRICE_MUST_BE_POSITIVE = "Selling Price must be a positive number,";
export const MSG_QUANTITY_REQUIRED = "Quantity is required.";
export const MSG_QUANTITY_MUST_BE_POSITIVE = "Quantity cannot be negative / zero,";
export const MSG_UOM_REQUIRED = "Unit of Measure (UOM) is required,";
export const MSG_BRAND_REQUIRED = "Brand is required,";
export const MSG_MANUFACTURER_REQUIRED = "Manufacturer is required.";
export const MSG_EXPIRY_DATE_INVALID = "Expiry Date is invalid.";
export const MSG_REORDER_POINT_INVALID = "Reorder Point must be a non-negative number.";
export const MSG_SELECT_ATTRIBUTE_OPTION = "Please select attribute and option";



export const MSG_PURCHASE_ORDER_DELETED="Purchase order deleted successfully";
export const MSG_PURCHASE_ORDER_UPDATED="Purchase order updated successfully";
export const MSG_PURCHASE_ORDER_ADDED="Purchase order added successfully";
export const MSG_PURCHASE_ORDER_FETCHED="Purchase order fetched successfully";
export const MSG_PURCHASE_ORDER_ERROR="Something went wrong";
export const MSG_PURCHASE_ORDER_NOT_FOUND="Purchase order not found";
export const MSG_PURCHASE_ORDER_NOT_UPDATED="Purchase order not updated";
export const MSG_PURCHASE_ORDER_NOT_ADDED="Purchase order not added";
export const MSG_PURCHASE_ORDER_NOT_FETCHED="Purchase order not fetched";


export const MSG_ALL_FIELDS_REQUIRED_TO_CREATE_USER="All fields are required to create a user.";
export const MSG_ALL_FIELDS_REQUIRED_TO_CREATE_SALES_PERSON="All fields are required to create a salesperson."
export const MSG_USER_CREATED="User created successfully.";
export const MSG_USER_NOT_CREATED="Failed to create user. Please try again.";
export const MSG_WAREHOUSE_ADDED= "Warehouse added successfully!";

